import React, { Fragment, useEffect, FC } from 'react';
import LoadingOverlay from 'ControlRoomComponents/loading-overlay';

import { history } from '../../app/history';
import useToLogin from '../../hooks/useToLogin';

interface AccessTokenProps {
  match: {
    params: {
      accessToken: string;
      orderId: string;
    };
  };
  login: ({ accessToken }: { accessToken: string }) => Promise<{ data: { login: string } }>;
}

export const HelpTokenLogin: FC<AccessTokenProps> = ({ match }: AccessTokenProps) => {
  const isLoggedIn = useToLogin({ params: match && match.params });

  useEffect(() => {
    if (isLoggedIn) {
      const { orderId } = match.params;
      history.push(`/help/${orderId}`);
    }
  }, [isLoggedIn]);

  return <LoadingOverlay visible />;
};
